<script>
/**
 * Consultation Feed Component
 */
export default {
  data() {
    return {
      months: [
        'January', 'February', 'March', 'April', 'May', 'June', 
        'July', 'August', 'September', 'October', 'November', 'December'
      ],
      timeframeOptions: [
        { value: 'all', text: 'All Year' },
        { value: 'current', text: 'Current Month' },
        { value: 'January', text: 'January' },
        { value: 'February', text: 'February' },
        { value: 'March', text: 'March' },
        { value: 'April', text: 'April' },
        { value: 'May', text: 'May' },
        { value: 'June', text: 'June' },
        { value: 'July', text: 'July' },
        { value: 'August', text: 'August' },
        { value: 'September', text: 'September' },
        { value: 'October', text: 'October' },
        { value: 'November', text: 'November' },
        { value: 'December', text: 'December' }
      ],
      chartColors: ['#556ee6', '#34c38f', '#f1b44c', '#f46a6a', '#50a5f1', '#f1b44c'],
      selectedTimeframe: 'current', // Default to current month
      goals: [
        {
          id: 1,
          icon: 'fas fa-weight',
          iconColor: 'danger',
          title: 'REDUCE',
          description: '10Kg Weight',
          progress: 70,
          progressColor: 'danger'
        },
        {
          id: 2,
          icon: 'fas fa-running',
          iconColor: 'success',
          title: 'WORKOUT',
          description: '30Min 4Days A Week',
          progress: 85,
          progressColor: 'success'
        },
        {
          id: 3,
          icon: 'fas fa-heartbeat',
          iconColor: 'warning',
          title: 'MAINTAIN',
          description: 'A1C levels',
          progress: 60,
          progressColor: 'warning'
        },
        {
          id: 4,
          icon: 'fas fa-utensils',
          iconColor: 'info',
          title: 'DIET',
          description: 'Balanced Nutrition Plan',
          progress: 75,
          progressColor: 'info'
        },
        {
          id: 5,
          icon: 'fas fa-bed',
          iconColor: 'primary',
          title: 'SLEEP',
          description: '7-8 Hours Daily',
          progress: 65,
          progressColor: 'primary'
        },
        {
          id: 6,
          icon: 'fas fa-tint',
          iconColor: 'info',
          title: 'HYDRATION',
          description: '2L Water Daily',
          progress: 80,
          progressColor: 'info'
        }
      ],
      consultationData: [
        {
          title: "Consultations",
          icon: "fas fa-stethoscope",
          value: "20",
          subvalue: "2.4%",
          selectedTimeframe: 'current', // Individual selection for each chart
          yearlyData: {
            // Full year data for line chart
            data: [
              { month: 'Jan', completed: 18, pending: 5, missed: 2 },
              { month: 'Feb', completed: 20, pending: 4, missed: 3 },
              { month: 'Mar', completed: 22, pending: 6, missed: 2 },
              { month: 'Apr', completed: 19, pending: 3, missed: 1 },
              { month: 'May', completed: 23, pending: 5, missed: 3 },
              { month: 'Jun', completed: 25, pending: 4, missed: 2 },
              { month: 'Jul', completed: 28, pending: 6, missed: 4 },
              { month: 'Aug', completed: 24, pending: 5, missed: 3 },
              { month: 'Sep', completed: 22, pending: 4, missed: 2 },
              { month: 'Oct', completed: 20, pending: 3, missed: 1 },
              { month: 'Nov', completed: 18, pending: 4, missed: 2 },
              { month: 'Dec', completed: 20, pending: 5, missed: 3 }
            ]
          },
          // Monthly data for each month (current month is December in this example)
          monthlyData: {
            'January': [
              { week: 'Week 1', completed: 4, pending: 1, missed: 0 },
              { week: 'Week 2', completed: 5, pending: 2, missed: 1 },
              { week: 'Week 3', completed: 6, pending: 1, missed: 0 },
              { week: 'Week 4', completed: 3, pending: 1, missed: 1 }
            ],
            'February': [
              { week: 'Week 1', completed: 5, pending: 1, missed: 1 },
              { week: 'Week 2', completed: 6, pending: 1, missed: 0 },
              { week: 'Week 3', completed: 4, pending: 1, missed: 1 },
              { week: 'Week 4', completed: 5, pending: 1, missed: 1 }
            ],
            'March': [
              { week: 'Week 1', completed: 6, pending: 2, missed: 0 },
              { week: 'Week 2', completed: 5, pending: 1, missed: 1 },
              { week: 'Week 3', completed: 7, pending: 2, missed: 1 },
              { week: 'Week 4', completed: 4, pending: 1, missed: 0 }
            ],
            'April': [
              { week: 'Week 1', completed: 5, pending: 1, missed: 0 },
              { week: 'Week 2', completed: 4, pending: 0, missed: 1 },
              { week: 'Week 3', completed: 6, pending: 1, missed: 0 },
              { week: 'Week 4', completed: 4, pending: 1, missed: 0 }
            ],
            'May': [
              { week: 'Week 1', completed: 6, pending: 1, missed: 1 },
              { week: 'Week 2', completed: 5, pending: 2, missed: 0 },
              { week: 'Week 3', completed: 7, pending: 1, missed: 1 },
              { week: 'Week 4', completed: 5, pending: 1, missed: 1 }
            ],
            'June': [
              { week: 'Week 1', completed: 7, pending: 1, missed: 0 },
              { week: 'Week 2', completed: 6, pending: 1, missed: 1 },
              { week: 'Week 3', completed: 8, pending: 1, missed: 1 },
              { week: 'Week 4', completed: 4, pending: 1, missed: 0 }
            ],
            'July': [
              { week: 'Week 1', completed: 8, pending: 2, missed: 1 },
              { week: 'Week 2', completed: 7, pending: 1, missed: 1 },
              { week: 'Week 3', completed: 9, pending: 2, missed: 1 },
              { week: 'Week 4', completed: 4, pending: 1, missed: 1 }
            ],
            'August': [
              { week: 'Week 1', completed: 6, pending: 1, missed: 1 },
              { week: 'Week 2', completed: 7, pending: 2, missed: 0 },
              { week: 'Week 3', completed: 6, pending: 1, missed: 1 },
              { week: 'Week 4', completed: 5, pending: 1, missed: 1 }
            ],
            'September': [
              { week: 'Week 1', completed: 5, pending: 1, missed: 0 },
              { week: 'Week 2', completed: 6, pending: 1, missed: 1 },
              { week: 'Week 3', completed: 7, pending: 1, missed: 1 },
              { week: 'Week 4', completed: 4, pending: 1, missed: 0 }
            ],
            'October': [
              { week: 'Week 1', completed: 5, pending: 1, missed: 0 },
              { week: 'Week 2', completed: 6, pending: 0, missed: 1 },
              { week: 'Week 3', completed: 5, pending: 1, missed: 0 },
              { week: 'Week 4', completed: 4, pending: 1, missed: 0 }
            ],
            'November': [
              { week: 'Week 1', completed: 4, pending: 1, missed: 1 },
              { week: 'Week 2', completed: 5, pending: 1, missed: 0 },
              { week: 'Week 3', completed: 6, pending: 1, missed: 1 },
              { week: 'Week 4', completed: 3, pending: 1, missed: 0 }
            ],
            'December': [
              { week: 'Week 1', completed: 5, pending: 2, missed: 1 },
              { week: 'Week 2', completed: 6, pending: 1, missed: 0 },
              { week: 'Week 3', completed: 5, pending: 1, missed: 1 },
              { week: 'Week 4', completed: 4, pending: 1, missed: 1 }
            ]
          },
          chartData: {
            series: [
              {
                name: "Completed",
                data: [5, 6, 5, 4]
              },
              {
                name: "Pending",
                data: [2, 1, 1, 1]
              },
              {
                name: "Missed",
                data: [1, 0, 1, 1]
              }
            ],
            chartOptions: {
              chart: {
                type: 'bar',
                height: 350,
                stacked: true,
                toolbar: {
                  show: false
                },
                zoom: {
                  enabled: false
                }
              },
              colors: ['#556ee6', '#f1b44c', '#f46a6a'],
              plotOptions: {
                bar: {
                  horizontal: false,
                  columnWidth: '45%',
                  endingShape: 'rounded'
                },
              },
              dataLabels: {
                enabled: false
              },
              stroke: {
                width: 1,
                colors: ['#fff']
              },
              xaxis: {
                categories: ['Week 1', 'Week 2', 'Week 3', 'Week 4'],
                labels: {
                  style: {
                    fontSize: '12px',
                    fontFamily: 'Helvetica, Arial, sans-serif',
                  }
                }
              },
              yaxis: {
                title: {
                  text: 'Number of Consultations'
                },
                labels: {
                  style: {
                    fontSize: '12px',
                    fontFamily: 'Helvetica, Arial, sans-serif',
                  }
                }
              },
              fill: {
                opacity: 1
              },
              legend: {
                position: 'bottom',
                horizontalAlign: 'center',
                fontSize: '12px',
                offsetY: 5
              },
              tooltip: {
                y: {
                  formatter: function (val) {
                    return val + " consultations"
                  }
                }
              }
            }
          }
        },
        {
          title: "Treatments",
          icon: "fas fa-procedures",
          value: "10",
          subvalue: "1.8%",
          selectedTimeframe: 'current', // Individual selection for each chart
          yearlyData: {
            // Full year data for line chart
            data: [
              { month: 'Jan', completed: 8, pending: 3, missed: 1 },
              { month: 'Feb', completed: 10, pending: 2, missed: 2 },
              { month: 'Mar', completed: 12, pending: 3, missed: 1 },
              { month: 'Apr', completed: 9, pending: 2, missed: 1 },
              { month: 'May', completed: 11, pending: 3, missed: 2 },
              { month: 'Jun', completed: 13, pending: 2, missed: 1 },
              { month: 'Jul', completed: 15, pending: 3, missed: 2 },
              { month: 'Aug', completed: 12, pending: 2, missed: 1 },
              { month: 'Sep', completed: 11, pending: 2, missed: 1 },
              { month: 'Oct', completed: 10, pending: 1, missed: 1 },
              { month: 'Nov', completed: 9, pending: 2, missed: 1 },
              { month: 'Dec', completed: 10, pending: 3, missed: 2 }
            ]
          },
          // Monthly data for each month (current month is December in this example)
          monthlyData: {
            'January': [
              { week: 'Week 1', completed: 2, pending: 1, missed: 0 },
              { week: 'Week 2', completed: 3, pending: 1, missed: 1 },
              { week: 'Week 3', completed: 2, pending: 0, missed: 0 },
              { week: 'Week 4', completed: 1, pending: 1, missed: 0 }
            ],
            'February': [
              { week: 'Week 1', completed: 3, pending: 0, missed: 1 },
              { week: 'Week 2', completed: 2, pending: 1, missed: 0 },
              { week: 'Week 3', completed: 3, pending: 1, missed: 1 },
              { week: 'Week 4', completed: 2, pending: 0, missed: 0 }
            ],
            'March': [
              { week: 'Week 1', completed: 3, pending: 1, missed: 0 },
              { week: 'Week 2', completed: 4, pending: 1, missed: 1 },
              { week: 'Week 3', completed: 3, pending: 1, missed: 0 },
              { week: 'Week 4', completed: 2, pending: 0, missed: 0 }
            ],
            'April': [
              { week: 'Week 1', completed: 2, pending: 1, missed: 0 },
              { week: 'Week 2', completed: 3, pending: 0, missed: 1 },
              { week: 'Week 3', completed: 2, pending: 1, missed: 0 },
              { week: 'Week 4', completed: 2, pending: 0, missed: 0 }
            ],
            'May': [
              { week: 'Week 1', completed: 3, pending: 1, missed: 1 },
              { week: 'Week 2', completed: 2, pending: 1, missed: 0 },
              { week: 'Week 3', completed: 4, pending: 1, missed: 1 },
              { week: 'Week 4', completed: 2, pending: 0, missed: 0 }
            ],
            'June': [
              { week: 'Week 1', completed: 4, pending: 0, missed: 0 },
              { week: 'Week 2', completed: 3, pending: 1, missed: 1 },
              { week: 'Week 3', completed: 4, pending: 1, missed: 0 },
              { week: 'Week 4', completed: 2, pending: 0, missed: 0 }
            ],
            'July': [
              { week: 'Week 1', completed: 4, pending: 1, missed: 1 },
              { week: 'Week 2', completed: 5, pending: 1, missed: 0 },
              { week: 'Week 3', completed: 4, pending: 1, missed: 1 },
              { week: 'Week 4', completed: 2, pending: 0, missed: 0 }
            ],
            'August': [
              { week: 'Week 1', completed: 3, pending: 0, missed: 0 },
              { week: 'Week 2', completed: 4, pending: 1, missed: 1 },
              { week: 'Week 3', completed: 3, pending: 1, missed: 0 },
              { week: 'Week 4', completed: 2, pending: 0, missed: 0 }
            ],
            'September': [
              { week: 'Week 1', completed: 3, pending: 1, missed: 0 },
              { week: 'Week 2', completed: 3, pending: 0, missed: 1 },
              { week: 'Week 3', completed: 3, pending: 1, missed: 0 },
              { week: 'Week 4', completed: 2, pending: 0, missed: 0 }
            ],
            'October': [
              { week: 'Week 1', completed: 3, pending: 0, missed: 0 },
              { week: 'Week 2', completed: 2, pending: 0, missed: 1 },
              { week: 'Week 3', completed: 3, pending: 1, missed: 0 },
              { week: 'Week 4', completed: 2, pending: 0, missed: 0 }
            ],
            'November': [
              { week: 'Week 1', completed: 2, pending: 1, missed: 0 },
              { week: 'Week 2', completed: 3, pending: 0, missed: 1 },
              { week: 'Week 3', completed: 2, pending: 1, missed: 0 },
              { week: 'Week 4', completed: 2, pending: 0, missed: 0 }
            ],
            'December': [
              { week: 'Week 1', completed: 3, pending: 1, missed: 1 },
              { week: 'Week 2', completed: 2, pending: 1, missed: 0 },
              { week: 'Week 3', completed: 3, pending: 0, missed: 1 },
              { week: 'Week 4', completed: 2, pending: 1, missed: 0 }
            ]
          },
          chartData: {
            series: [
              {
                name: "Completed",
                data: [3, 2, 3, 2]
              },
              {
                name: "Pending",
                data: [1, 1, 0, 1]
              },
              {
                name: "Missed",
                data: [1, 0, 1, 0]
              }
            ],
            chartOptions: {
              chart: {
                type: 'bar',
                height: 350,
                stacked: true,
                toolbar: {
                  show: false
                },
                zoom: {
                  enabled: false
                }
              },
              colors: ['#556ee6', '#f1b44c', '#f46a6a'],
              plotOptions: {
                bar: {
                  horizontal: false,
                  columnWidth: '45%',
                  endingShape: 'rounded'
                },
              },
              dataLabels: {
                enabled: false
              },
              stroke: {
                width: 1,
                colors: ['#fff']
              },
              xaxis: {
                categories: ['Week 1', 'Week 2', 'Week 3', 'Week 4'],
                labels: {
                  style: {
                    fontSize: '12px',
                    fontFamily: 'Helvetica, Arial, sans-serif',
                  }
                }
              },
              yaxis: {
                title: {
                  text: 'Number of Treatments'
                },
                labels: {
                  style: {
                    fontSize: '12px',
                    fontFamily: 'Helvetica, Arial, sans-serif',
                  }
                }
              },
              fill: {
                opacity: 1
              },
              legend: {
                position: 'bottom',
                horizontalAlign: 'center',
                fontSize: '12px',
                offsetY: 5
              },
              tooltip: {
                y: {
                  formatter: function (val) {
                    return val + " treatments"
                  }
                }
              }
            }
          }
        }
      ]
    };
  },
  mounted() {
    // Initialize charts with correct data based on default timeframe
    this.consultationData.forEach((item, index) => {
      this.updateChartData(index);
    });
  },
  methods: {
    // Update the timeframe for a specific chart
    updateTimeframe(index, value) {
      // Update the selected timeframe for the specific chart
      this.consultationData[index].selectedTimeframe = value;

      // Update chart data and options based on the selected timeframe
      this.updateChartData(index);
    },

    // Update chart data and options based on the selected timeframe
    updateChartData(index) {
      const item = this.consultationData[index];
      const timeframe = item.selectedTimeframe;
      const title = item.title.toLowerCase();

      // Set chart type to pie for both consultation and treatment
      const chartType = 'pie';

      // Update chart options
      item.chartData.chartOptions.chart.type = chartType;
      item.chartData.chartOptions.chart.stacked = false;

      // Prepare data for pie chart
      let pieData = [];
      let pieLabels = [];

      if (timeframe === 'all') {
        // For 'all', aggregate yearly data
        const totalCompleted = item.yearlyData.data.reduce((sum, month) => sum + month.completed, 0);
        // Removed pending and missed indicators as per requirement

        // For consultation, add IP/OP data
        if (title === 'consultations') {
          const totalIP = Math.round(totalCompleted * 0.4); // 40% of completed are IP
          const totalOP = totalCompleted - totalIP; // 60% of completed are OP

          pieData = [totalIP, totalOP];
          pieLabels = ["IP", "OP"];
        } else {
          // For treatment, add Surgical/Non-surgical data
          const totalSurgical = Math.round(totalCompleted * 0.35); // 35% of completed are Surgical
          const totalNonSurgical = totalCompleted - totalSurgical; // 65% of completed are Non-surgical

          pieData = [totalSurgical, totalNonSurgical];
          pieLabels = ["Surgical", "Non-surgical"];
        }
      } else {
        // For specific month or current month
        const monthData = timeframe === 'current' ? item.monthlyData['December'] : item.monthlyData[timeframe];
        const totalCompleted = monthData.reduce((sum, week) => sum + week.completed, 0);
        // Removed pending and missed indicators as per requirement

        // For consultation, add IP/OP data
        if (title === 'consultations') {
          const totalIP = Math.round(totalCompleted * 0.4); // 40% of completed are IP
          const totalOP = totalCompleted - totalIP; // 60% of completed are OP

          pieData = [totalIP, totalOP];
          pieLabels = ["IP", "OP"];
        } else {
          // For treatment, add Surgical/Non-surgical data
          const totalSurgical = Math.round(totalCompleted * 0.35); // 35% of completed are Surgical
          const totalNonSurgical = totalCompleted - totalSurgical; // 65% of completed are Non-surgical

          pieData = [totalSurgical, totalNonSurgical];
          pieLabels = ["Surgical", "Non-surgical"];
        }
      }

      // Update series for pie chart
      item.chartData.series = pieData;

      // Update chart options for pie chart
      item.chartData.chartOptions = {
        chart: {
          type: 'pie',
          height: 240,
          toolbar: {
            show: false
          }
        },
        labels: pieLabels,
        colors: this.chartColors,
        legend: {
          show: true,
          position: 'bottom',
          horizontalAlign: 'center',
          fontSize: '12px',
          offsetY: 5
        },
        responsive: [{
          breakpoint: 600,
          options: {
            chart: {
              height: 200
            },
            legend: {
              position: 'bottom'
            }
          }
        }],
        tooltip: {
          y: {
            formatter: function (val) {
              return val + " " + (title === 'consultations' ? 'consultations' : 'treatments');
            }
          }
        }
      };

      // Update the total value displayed
      if (timeframe === 'all') {
        // For yearly view, show the total for the year
        const totalCompleted = item.yearlyData.data.reduce((sum, month) => sum + month.completed, 0);
        item.value = totalCompleted.toString();
      } else {
        // For monthly view, show the total for the selected month
        const monthData = timeframe === 'current' ? item.monthlyData['December'] : item.monthlyData[timeframe];
        const totalCompleted = monthData.reduce((sum, week) => sum + week.completed, 0);
        item.value = totalCompleted.toString();
      }
    }
  }
};
</script>

<template>
  <div class="card">
    <div class="card-body">
      <h4 class="card-title mb-4">Consultation & Treatment Indicators</h4>
      <div class="row">
        <!-- Consultation and Treatment Pie Charts -->
        <div class="col-md-4" v-for="(item, index) in consultationData" :key="index">
          <div class="card mb-3 shadow-sm" :class="`feed-card-${index}`">
            <div class="card-header bg-gradient-light py-2">
              <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center">
                  <div class="avatar-sm rounded-circle bg-soft-primary mr-2 d-flex align-items-center justify-content-center">
                    <i :class="`${item.icon} font-size-16 text-primary`"></i>
                  </div>
                  <div>
                    <h5 class="mb-0 font-weight-bold">{{ item.title }} <span class="badge badge-soft-primary ml-1">{{ item.value }}</span></h5>
                  </div>
                </div>

                <!-- Timeframe Selector -->
                <div class="form-group mb-0">
                  <select 
                    class="form-control form-control-sm custom-select border-0 bg-soft-light" 
                    v-model="item.selectedTimeframe"
                    @change="updateTimeframe(index, item.selectedTimeframe)"
                  >
                    <option v-for="option in timeframeOptions" :key="option.value" :value="option.value">
                      {{ option.text }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div class="card-body py-2">
              <div class="row">
                <!-- Pie Chart -->
                <div class="col-md-8">
                  <div class="border rounded p-2 bg-soft-light shadow-sm">
                    <apexchart
                      class="apex-charts"
                      height="240"
                      :type="item.chartData.chartOptions.chart.type"
                      dir="ltr"
                      :series="item.chartData.series"
                      :options="item.chartData.chartOptions"
                    ></apexchart>
                  </div>
                </div>

                <!-- Stats Summary -->
                <div class="col-md-4">
                  <div class="d-flex flex-column justify-content-center h-100">
                    <div class="stats-item mb-2 p-2 rounded bg-soft-primary">
                      <h6 class="mb-0">Total</h6>
                      <div class="d-flex justify-content-between">
                        <span>Total:</span>
                        <span class="font-weight-bold">{{ item.chartData.series.reduce((a, b) => a + b, 0) }}</span>
                      </div>
                    </div>

                    <div class="stats-item mb-2 p-2 rounded bg-soft-success">
                      <h6 class="mb-0">Yearly</h6>
                      <div class="d-flex justify-content-between">
                        <span>Total:</span>
                        <span class="font-weight-bold">{{ item.yearlyData.data.reduce((sum, month) => sum + month.completed + month.pending + month.missed, 0) }}</span>
                      </div>
                    </div>

                    <div class="stats-item p-2 rounded bg-soft-info">
                      <div class="d-flex align-items-center">
                        <div :class="parseFloat(item.subvalue) > 0 ? 'avatar-xs bg-soft-success rounded-circle mr-2' : 'avatar-xs bg-soft-danger rounded-circle mr-2'">
                          <span class="avatar-title rounded-circle">
                            <i :class="parseFloat(item.subvalue) > 0 ? 'mdi mdi-arrow-up-bold font-size-12 text-success' : 'mdi mdi-arrow-down-bold font-size-12 text-danger'"></i>
                          </span>
                        </div>
                        <div>
                          <span :class="parseFloat(item.subvalue) > 0 ? 'text-success font-weight-bold' : 'text-danger font-weight-bold'">
                            {{ item.subvalue }}
                          </span>
                          <span class="text-muted ml-1">vs prev</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Goals Section -->
        <div class="col-md-4">
          <div class="card mb-3 shadow-sm feed-card-2">
            <div class="card-header bg-gradient-light py-2">
              <div class="d-flex align-items-center">
                <div class="avatar-sm rounded-circle bg-soft-primary mr-2 d-flex align-items-center justify-content-center">
                  <i class="fas fa-bullseye font-size-16 text-primary"></i>
                </div>
                <div>
                  <h5 class="mb-0 font-weight-bold">GOAL'S</h5>
                </div>
              </div>
            </div>

            <div class="card-body py-2">
              <div class="goals-container" style="max-height: 240px; overflow-y: auto;">
                <div v-for="goal in goals" :key="goal.id" class="goal-item mb-2 p-2 bg-light-primary rounded shadow-sm border-start" :class="`border-${goal.progressColor}`" style="border-width: 3px !important;">
                  <div class="d-flex align-items-center mb-1">
                    <i :class="`${goal.icon} text-${goal.iconColor} me-2`"></i>
                    <p class="mb-0"><strong>{{ goal.title }}:</strong> {{ goal.description }}</p>
                    <span class="ms-auto">{{ goal.progress }}%</span>
                  </div>
                  <div class="progress" style="height: 8px;">
                    <div class="progress-bar" :class="`bg-${goal.progressColor}`" role="progressbar" :style="`width: ${goal.progress}%;`" :aria-valuenow="goal.progress" aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Goals Section -->

    </div>
  </div>
</template>

<style scoped>
.bg-gradient-light {
  background: linear-gradient(to right, #f8f9fa, #ffffff);
}

.bg-soft-primary {
  background-color: rgba(85, 110, 230, 0.15) !important;
}

.bg-soft-success {
  background-color: rgba(52, 195, 143, 0.15) !important;
}

.bg-soft-danger {
  background-color: rgba(244, 106, 106, 0.15) !important;
}

.bg-soft-light {
  background-color: rgba(248, 249, 250, 0.5) !important;
}

.bg-light-primary {
  background-color: rgba(85, 110, 230, 0.1) !important;
}

.text-success {
  color: #34c38f !important;
}

.text-danger {
  color: #f46a6a !important;
}

.text-primary {
  color: #556ee6 !important;
}

.text-warning {
  color: #f1b44c !important;
}

.text-info {
  color: #50a5f1 !important;
}

.avatar-sm {
  height: 3rem;
  width: 3rem;
}

.avatar-xs {
  height: 2rem;
  width: 2rem;
}

.avatar-title {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
}

.shadow-sm {
  box-shadow: 0 .125rem .25rem rgba(0,0,0,.075) !important;
}

.btn-soft-primary {
  background-color: rgba(85, 110, 230, 0.15);
  border-color: transparent;
  color: #556ee6;
}

.btn-soft-primary:hover {
  background-color: #556ee6;
  color: #fff;
}

.custom-select {
  transition: all 0.3s ease;
}

.custom-select:focus {
  box-shadow: none;
  border-color: #556ee6;
}

.feed-card-0 {
  border-top: 3px solid #556ee6;
}

.feed-card-1 {
  border-top: 3px solid #34c38f;
}

/* Goals Section Styles */
.border-primary {
  border-color: #556ee6 !important;
}

.border-success {
  border-color: #34c38f !important;
}

.border-danger {
  border-color: #f46a6a !important;
}

.border-warning {
  border-color: #f1b44c !important;
}

.border-info {
  border-color: #50a5f1 !important;
}

.me-2 {
  margin-right: 0.5rem !important;
}

.ms-auto {
  margin-left: auto !important;
}

.fw-bold {
  font-weight: bold !important;
}

.goal-item {
  transition: all 0.3s ease;
}

.goal-item:hover {
  transform: translateY(-3px);
  box-shadow: 0 .5rem 1rem rgba(0,0,0,.15) !important;
}
</style>
